import { useState } from "react";
import {
	formatSimulationPayload,
	formatSimulationResponse,
	validateSimulationCalculationFields
} from "../utils/simulacao-utils";
import { throwResponseError } from "../../utils/api-error-utils";
import { getAuthParams } from "../../utils/pacto-rebates-utils";
import { hasValidationErrors } from "../../utils/validation-utils";

export function useSimulation() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    async function createSimulation(payloadData) {
        try {
            setLoading(true);
            setError(null);

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const calculationErrorMessage = "Valor do equipamento insuficiente para o cálculo.";

            const calculationErrors = validateSimulationCalculationFields({
                ...payloadData,
                equipmentValueErrorMessage: calculationErrorMessage
            });

            if (hasValidationErrors(calculationErrors)) {
                setValidationErrors(calculationErrors);

                return {
                    ok: false,
                    isValidationError: true,
                    error: calculationErrorMessage,
                    validationErrors: calculationErrors
                };
            }

            setValidationErrors({});

            const body = formatSimulationPayload(payloadData);

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                },
                body: JSON.stringify(body)
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-simulador/v1/simulacoes`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível salvar a simulação."
                );
            }

            const data = await response.json();

            const simulationData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedSimulation = formatSimulationResponse(simulationData);

            return {
                ok: true,
                simulation: formattedSimulation
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        validationErrors,
        createSimulation
    };
}